import { useScriptCloudflareWebAnalytics, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const cloudflareWebAnalytics = useScriptCloudflareWebAnalytics({"token":"a36420a59a694c24b5f95f9bd3ed9495"})
    return { provide: { $scripts: { cloudflareWebAnalytics } } }
  }
})